// chart.js is not able to add linebreaks in labels without custom logic :(
export const formatLabel = (label: string, maxWidth: number) => {
    let sections: string[] = [];
    let words = label.split(" ");
    let temp = "";

    words.forEach((word, index) => {
        if (temp.length > 0) {
            let concat = temp + " " + word;

            if (concat.length > maxWidth) {
                sections.push(temp);
                temp = "";
            } else {
                if (index === words.length - 1) {
                    sections.push(concat);
                    return;
                }
                temp = concat;
                return;
            }
        }

        if (index === words.length - 1) {
            sections.push(word);
            return;
        }

        if (word.length < maxWidth) {
            temp = word;
            return;
        }

        sections.push(word);
    });

    return sections;
};
